import { BaseElement } from './base-element';
import { ElementType } from './element-type';

export class Tabs extends BaseElement {
  tabList: Tab[] = [];

  constructor() {
    super();
    this.elementType = ElementType.tabs;
  }
}

export class Tab extends BaseElement {
  title: string | null = null;

  constructor() {
    super();
  }
}
